module.exports = require("core-js/library/fn/object/get-own-property-symbols");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/core-js/object/get-own-property-symbols.js
// module id = 120
// module chunks = 35783957827783 52252321336229